/*
 * Copyright (c) Nexign, JSC, 2021-2025.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Nikolay Sviridov
 * @version 1.36.0
 * @since 1.14.1
 */

export enum EWizardBillsDocSteps {
    AccountsChooseStep = 'AccountsChooseStep',
    BillsChooseStep = 'BillsChooseStep',
    StepChoose = 'ChooseStep',
    StepConfirmation = 'ConfirmStep',
}

/*
* -------------------------------------------
*           ACTIONS
* -------------------------------------------
*/

export const WIZARD_BILLS_DOC_VALIDATE_START = '@@b2b_portal_ui/wizardBillsDoc/WIZARD_BILLS_DOC_VALIDATE_START';
export const WIZARD_BILLS_DOC_VALIDATE_FINISH = '@@b2b_portal_ui/wizardBillsDoc/WIZARD_BILLS_DOC_VALIDATE_FINISH';

export const WIZARD_BILLS_DOC_SET_PARAMS = '@@b2b_portal_ui/wizardBillsDoc/WIZARD_BILLS_DOC_SET_PARAMS';

export const WIZARD_BILLS_DOC_HANDLE_NEXT = '@@b2b_portal_ui/wizardBillsDoc/WIZARD_BILLS_DOC_HANDLE_NEXT';
